import { NavLink } from "react-router-dom";
import "../../Styles/dashboard/product.css"
import {BiEditAlt} from "react-icons/bi"
import {RiDeleteBin6Line} from "react-icons/ri"
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Loader from "react-js-loader";
import { useEffect, useState } from "react";
import Sidebar from "../../components/dashboard/sidebar";
import { productColumns, productsRow } from "../../components/dashboard/data";
import { url } from "../../db/url";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

export const ProductDashboard = () => {
    // get request for all products based on a category which will be saved in the url
    
    const [fetch, setFetched] = useState(false)
    const [products, setProducts] = useState([])

    const navigate = useNavigate()

    useEffect(() => {
        axios.get(`${url}/api/v2/product/get-all-products`)
        .then(res => {
            setFetched(true)
            setProducts(productsRow)
        }).catch(err => {
            toast.error(err.response ? err.response.data.message : "Network Error")
        })
    }, [])

    const deleteProduct = () => {

    }

    return<>
        <Sidebar/>
        {
            !fetch ?
            <div className="loader">
                <Loader type="box-rectangular" bgColor={"rgb(190,142,30)"} title={"box-rotate-x"} color={'green'} size={50} />
            </div> :
        
        <div className="productContainer">
            <div className="pageInfo">
                <h2>Product <span>{products.length} product found</span></h2>
                <NavLink to={'/dashboard/product/add'}> Add Product</NavLink>
            </div>

            <div className="productDetails">
                    <DataTable
                        pagination
                        columns={productColumns}
                        data= {
                            products.map(data => {
                                return(
                                    {
                                        id:  data.id,
                                        productImage: <img src={data.images && data.images[0].url} alt="" />,
                                        productName: <p>{data.name}</p>,
                                        description: <p> {data.description}</p>,
                                        ratings: <p>{data.ratings}</p>,
                                        category: <p>{data.category}</p>,
                                        productPrice: <p>{data.originalPrice}</p>,
                                        discountPrice: <p>{data.discountPrice}</p>,
                                        edit: <BiEditAlt className="edit" onClick={() => navigate(`/dashboard/product/edit/${data.id}`)}/>, 
                                        delete: <RiDeleteBin6Line className="delete" onClick={() => deleteProduct(data)}/>
                                    }
                                )  
                            })
                        }
                        striped
                        responsive
                        className="datatable"
                        
                    />
            </div>
        </div>
        }
    </>

}

export default ProductDashboard